import {
    useCallback,
    useContext,
    useTransition
} from "react"
import { AuthUIContext } from "../lib/auth-ui-provider"
import { getSearchParam } from "../lib/utils"

export function useOnSuccessTransition({
    redirectTo: redirectToProp
}: {
    redirectTo?: string
}) {
    const { redirectTo: contextRedirectTo } = useContext(AuthUIContext)

    const getRedirectTo = useCallback(
        () =>
            redirectToProp || getSearchParam("redirectTo") || contextRedirectTo,
        [redirectToProp, contextRedirectTo]
    )

    const [isPending, startTransition] = useTransition()
    const {
        navigate,
        hooks: { useSession },
        onSessionChange
    } = useContext(AuthUIContext)

    const { refetch: refetchSession } = useSession()

    const onSuccess = useCallback(async () => {
        await refetchSession?.()
        await onSessionChange?.()

        startTransition(() => {
            navigate(getRedirectTo())
        })
    }, [refetchSession, onSessionChange, navigate, getRedirectTo])

    return { onSuccess, isPending }
}
